@if (pendingCanvasExportAttemptIds().length > 0 && state.userId) {
  <dojo-hidden-canvas-exporter
    [userId]="state.userId"
    [attemptIds]="pendingCanvasExportAttemptIds()"
    (exportsReady)="onHiddenExportsReady($event)"
  />
}

<dojo-examdojo-question
  [isTransitioningBetweenQuestions]="isTransitioningBetweenQuestions()"
  [shouldShowRightSidebar]="state.shouldShowRightSidebar"
  [isTimeUp]="state.isTimeUp"
  [showExitButton]="state.shouldShowExitButton"
  [sidebarTemplateRef]="questionSelectorTemplate"
  [footerTemplateRef]="footerTemplate"
  [loadingTemplateRef]="loadingTemplate"
  [mobileHeaderCenterTemplateRef]="state.challengeActivityStatus === 'IN_PROGRESS' ? mobileHeaderCenterTemplate : null"
  [questionStatusSelectorTemplate]="questionStatusSelectorTemplate"
  (completed)="onQuestionCompleted('stop')"
/>
<ng-template #questionSelectorTemplate>
  <div
    [class.md:max-h-[calc(100vh-76px)]]="!isCanvasVisible() || isDesktop"
    class="bg-neutral-0 z-2 sticky top-0 flex flex-col border-b border-neutral-200 md:static md:h-full md:border-b-0 md:border-r"
  >
    <dojo-challenge-activity-question-selector class="min-h-0 flex-1" />

    @if (state.challengeActivityStatus === 'IN_PROGRESS') {
      <wide-layout>
        <div class="flex-shrink-0 border-t border-neutral-200 px-2 py-3">
          <dojo-exam-time class="mt-1" />
        </div>
      </wide-layout>
    }
  </div>
</ng-template>

<ng-template #footerTemplate>
  @if (!isCanvasVisible() || isDesktop) {
    <small-layout>
      <dojo-footer-panel>
        <div class="right item-center flex flex-row justify-end gap-2">
          @if (state.challengeActivityStatus !== 'IN_PROGRESS') {
            <dojo-button
              [disabled]="state.challengeActivityStatus === 'SUBMITTED'"
              [pending]="submittingSelfGrading()"
              fill="solid"
              (click)="submitSelfGradingAndComplete()"
              [ngClass]="
                state.isQuestionMultipleChoice && state.challengeActivityStatus === 'GRADED'
                  ? 'small:w-auto mr-[96px] block w-full'
                  : 'w-full md:min-w-[178px]'
              "
            >
              {{ 'challenge.finish' | transloco }}
            </dojo-button>
          } @else {
            <dojo-button
              [fill]="state.allQuestionAttemptsDone || state.isTimeUp ? 'solid' : 'outline'"
              (click)="gradeChallengeActivity()"
              class="w-full md:min-w-[178px]"
            >
              {{ 'challenge.finish_and_submit' | transloco }}
            </dojo-button>
          }
        </div>
      </dojo-footer-panel>
    </small-layout>
    <wide-layout>
      <dojo-footer-panel [limitWidthContainer]="false">
        <div left>
          @if (state.shouldShowExitButton) {
            <dojo-button
              fill="outline"
              (click)="onQuestionCompleted('stop')"
              [customColor]="'red'"
              class="w-full md:min-w-[178px]"
            >
              {{ 'exams.end' | transloco }}
            </dojo-button>
          }
        </div>
        <div right class="flex items-center justify-end gap-2">
          @if (state.challengeActivityStatus !== 'IN_PROGRESS') {
            <dojo-button
              [disabled]="state.challengeActivityStatus === 'SUBMITTED'"
              [pending]="submittingSelfGrading()"
              fill="solid"
              (click)="submitSelfGradingAndComplete()"
              class="w-full md:min-w-[178px]"
            >
              {{ 'challenge.finish' | transloco }}
            </dojo-button>
          } @else {
            <dojo-button
              [fill]="state.allQuestionAttemptsDone || state.isTimeUp ? 'solid' : 'outline'"
              (click)="gradeChallengeActivity()"
              class="w-full md:min-w-[178px]"
            >
              {{ 'challenge.finish_and_submit' | transloco }}
            </dojo-button>
          }
        </div>
      </dojo-footer-panel>
    </wide-layout>
  }
</ng-template>

<ng-template #loadingTemplate>
  <dojo-challenge-grading-loading />
</ng-template>

<ng-template #mobileHeaderCenterTemplate>
  <dojo-exam-time />
</ng-template>

<ng-template #questionStatusSelectorTemplate>
  <dojo-challenge-activity-question-status-selector class="ml-auto" />
</ng-template>
